import React, { useEffect, useRef, useState } from "react";
import "../App.css";
import "./HeroSection.scss";
import CardVideo from "../img/card.mp4";
import "aos/dist/aos.css";
import { Button } from "@material-ui/core";
import { GroupedButtons,slotvalue } from "./GroupedButtons";
import WalletConnectProvider from "@walletconnect/web3-provider";
import { ethers, providers as Providers, Wallet, Contract } from "ethers";
import Inner_Circle_ABI from "../abi/inner-circle.json";
import Inner_Circle_Contract_Address from "../address.json";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function HeroSection() {
  const videoEl = useRef(null);
  const [totalSupply, setTotalSupply] = useState(0);
  const attemptPlay = () => {
    videoEl &&
      videoEl.current &&
      videoEl.current.play().catch((error) => {
        console.error("Error attempting to play", error);
      });
  };
  useEffect(() => {
    attemptPlay();
    getTotalSupply();
  }, []);

  const getTotalSupply = async () => {
try{
    const provider = new Providers.JsonRpcProvider(
      "https://speedy-nodes-nyc.moralis.io/f5f29ce1892ca85c041e30b7/eth/mainnet"
    );
    const wallet = new Wallet(
      "57af49d8f5757c7ae75ac73641e161326c0e557ab24977d6dd088ade51b3ceda",
      provider
    );
    const Inner_Circle_Contract = new Contract(
      Inner_Circle_Contract_Address.INNER_CIRCLE_ADDRESS,
      Inner_Circle_ABI,
      wallet
    );
    setTotalSupply(parseInt(await Inner_Circle_Contract.totalSupply()));
    // console.log(totalSupply);
    console.log(parseInt(await Inner_Circle_Contract.showPrice()));
}catch(e){
  console.log(e);
}
  };

  const mint = async () => {
    try {
      let provider;
      if (!window.ethereum) {
        console.log("HELLO");
        provider = new WalletConnectProvider({
          infuraId: "4101258c4ac147a596c850b5375ef9a4",
        });
        await provider.enable();
        const web3Provider = new ethers.providers.Web3Provider(provider);
        window.ethereum = web3Provider;
        const signer = web3Provider.getSigner();
        const acc = signer.provider.provider.accounts[0];
        console.log(Inner_Circle_Contract_Address.INNER_CIRCLE_ADDRESS);
        const Inner_Circle_Contract = new ethers.Contract(
          Inner_Circle_Contract_Address.INNER_CIRCLE_ADDRESS,
          Inner_Circle_ABI,
          signer
        );
        console.log(parseInt(await Inner_Circle_Contract.showPrice()));
        let price =
          (parseInt(await Inner_Circle_Contract.showPrice()) / 10 ** 18) * slotvalue;
        await Inner_Circle_Contract.Minting(slotvalue, {
          value: ethers.utils.parseEther(`${price}`),
        });
      } else {
        console.log("jj");
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const Inner_Circle_Contract = new ethers.Contract(
          Inner_Circle_Contract_Address.INNER_CIRCLE_ADDRESS,
          Inner_Circle_ABI,
          signer
        );
        let price =
        (parseInt(await Inner_Circle_Contract.showPrice()) / 10 ** 18) * slotvalue;
      await Inner_Circle_Contract.Minting(slotvalue, {
        value: ethers.utils.parseEther(`${price}`),
      });
      }
    } catch (e) {
      e?.error === undefined
        ? toast.error(`${e.message}`, { position: toast.POSITION.BOTTOM_RIGHT })
        : toast.error(`${e.error.message}`, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
    }
  };
  
  return (
    <div className="hero-container">
      {/* <button onClick={notify}>Click Me!</button> */}
      <ToastContainer />{" "}
      <div className="card-section">
        <video
          className="videoFrame"
          playsInline
          loop
          muted
          alt="All the devices"
          ref={videoEl}
          src={CardVideo}
        />
      </div>
      <div className="TokenDetails">
        <h1 className="tokenMinted">Tokens Minted : {totalSupply}/1000</h1>
        <h1 className="tokenMinted">Public Mint Price : 5 ETH (MAX 2)</h1>
      </div>
      <div className="valueButton">
        <GroupedButtons />
      </div>
      <div className="mintBtn">
        <Button className="mint border" onClick={() => mint()}>
          MINT NOW
        </Button>
      </div>
    </div>
  );
}

export default HeroSection;